// ante-react-kit/src/components/v2/AntHeaderCard/StatusTheme.js

const STATUS_THEMES = {
    New: {
        accent: '#94A3B8',
        bg: '#FFFFFF',
        text: '#64748B',
        border: '#CBD5E1',
        textOpacity: 1,
        summaryFontScale: 'compact',
        autoExpandSections: ['customer'],
        secondaryMode: 'collapsed',
        editHighlight: true
    },
    Release: {
        accent: '#22C55E',
        bg: '#F0FDF4',
        text: '#166534',
        border: '#86EFAC',
        textOpacity: 1,
        summaryFontScale: 'normal',
        autoExpandSections: [],
        secondaryMode: 'preview',
        editHighlight: false
    },
    Open: {
        accent: '#F59E0B',
        bg: '#FFFFFF',
        text: '#92400E',
        border: '#FCD34D',
        textOpacity: 1,
        summaryFontScale: 'normal',
        autoExpandSections: ['delivery'],
        secondaryMode: 'preview',
        editHighlight: false
    },
    Close: {
        accent: '#0EA5E9',
        bg: '#FFFFFF',
        text: '#0369A1',
        border: '#7DD3FC',
        textOpacity: 0.85,
        summaryFontScale: 'compact',
        autoExpandSections: [],
        secondaryMode: 'inline',
        editHighlight: false
    },
    Cancel: {
        accent: '#EF4444',
        bg: '#FFF5F5',
        text: '#991B1B',
        border: '#FCA5A5',
        textOpacity: 0.5,
        summaryFontScale: 'strikethrough',
        autoExpandSections: [],
        secondaryMode: 'hidden',
        editHighlight: false
    }
};

const DEFAULT_THEME = STATUS_THEMES.New;

export function getStatusTheme(status) {
    return STATUS_THEMES[status] || DEFAULT_THEME;
}

export function getStatusAccentStyle(status) {
    var theme = getStatusTheme(status);
    return { borderLeftColor: theme.accent };
}

export default STATUS_THEMES;
